<template>
	<div>
		<template v-if="isMobile">
			<GridLayout grid-color="gray100" grid-fluid>
				<GridLayout>
					<c-new-col :col-lg="12">
						<div class="partner-kb-container">
							<div class="partner-kb-banner-vp-container">
								<c-typography type="body1" color="gray850"> KB국민은행이 지원하는 </c-typography>
								<c-typography class="mb-8" type="headline1" color="gray850">
									진짜 현직자와 <br />찐한 직무경험
								</c-typography>
							</div>
							<img
								class="partner-kb-banner-illust"
								:src="`/images/edu/partner/edu-partner-kb-banner-illust-m.svg` | getCdnImageSrc"
								alt=""
							/>
						</div>
					</c-new-col>
				</GridLayout>
			</GridLayout>
			<GridLayout grid-color="gray000" grid-fluid>
				<GridLayout>
					<c-new-col :col-lg="12">
						<div class="partner-kb-sponsor-container">
							<PartnerKBSponsorItem role="주최">
								<template v-slot:logo>
									<c-logo width="64px" height="11px" :url="null" />
								</template>
							</PartnerKBSponsorItem>
							<PartnerKBSponsorItem role="주관">
								<template v-slot:logo>
									<img
										:src="`/images/edu/partner/edu-partner-kwangjingu-logo.svg` | getCdnImageSrc"
										alt="광진구"
									/>
								</template>
							</PartnerKBSponsorItem>
							<PartnerKBSponsorItem role="협찬">
								<template v-slot:logo>
									<img
										:src="`/images/edu/partner/edu-partner-kb-logo.svg` | getCdnImageSrc"
										alt="KB국민은행"
									/>
								</template>
							</PartnerKBSponsorItem>
						</div>
					</c-new-col>
				</GridLayout>
			</GridLayout>
		</template>
		<template v-else>
			<GridLayout grid-color="gray100" grid-fluid>
				<GridLayout>
					<c-new-col :col-lg="12">
						<div class="partner-kb-container">
							<div class="partner-kb-banner-vp-container">
								<c-typography class="mb-8" type="display1" color="gray850">
									전액무료 직무부트캠프 참가자 모집
								</c-typography>
								<c-typography type="headline5" color="gray800" :font-weight="400">
									KB국민은행이 서울시 청년 구직자를 지원합니다
								</c-typography>
							</div>
							<img
								class="partner-kb-banner-illust"
								:src="`/images/edu/partner/edu-partner-kb-banner-illust.svg` | getCdnImageSrc"
								alt=""
							/>
						</div>
					</c-new-col>
				</GridLayout>
			</GridLayout>
			<GridLayout grid-color="gray000" grid-fluid>
				<GridLayout>
					<c-new-col :col-lg="12">
						<div class="partner-kb-sponsor-container">
							<PartnerKBSponsorItem role="주관">
								<template v-slot:logo>
									<c-logo width="82px" height="14px" :url="null" />
								</template>
							</PartnerKBSponsorItem>
							<PartnerKBSponsorItem role="후원">
								<template v-slot:logo>
									<img
										:src="`/images/edu/partner/edu-partner-kwangjingu-logo.svg` | getCdnImageSrc"
										alt="광진구청"
									/>
								</template>
							</PartnerKBSponsorItem>
							<PartnerKBSponsorItem role="주최">
								<template v-slot:logo>
									<img
										:src="`/images/edu/partner/edu-partner-kb-logo.svg` | getCdnImageSrc"
										alt="KB국민은행"
									/>
								</template>
							</PartnerKBSponsorItem>
						</div>
					</c-new-col>
				</GridLayout>
			</GridLayout>
		</template>
	</div>
</template>

<script>
import { getCdnImageSrc } from '../../../../utils/util';
import PartnerKBSponsorItem from './PartnerKBSponsorItem.vue';
import GridLayout from '../../../common/GridLayout.vue';
export default {
	name: 'PartnerKBBanner',
	filters: {
		getCdnImageSrc,
	},
	components: { GridLayout, PartnerKBSponsorItem },
};
</script>

<style lang="scss" scoped>
@import 'resources/assets/scss/base/main';

$banner-height: 300px;
$banner-height-m: 250px;
$sponsor-banner-height: 38px;
$sponsor-banner-height-m: 35px;
.partner-kb {
	&-container {
		position: relative;
		@include pc {
			padding-top: 88px;
			height: $banner-height - $sponsor-banner-height;
		}
		@include mobile {
			padding-top: 32px;
			height: 251px;
		}
	}
	&-banner {
		&-illust {
			position: absolute;
			bottom: 0;
			@include pc {
				right: 0;
			}
			@include mobile {
				right: -16px;
			}
		}
	}
	&-sponsor-container {
		@include flexbox();
		@include align-items(center);
		@include pc {
			float: right;
			height: $sponsor-banner-height;
		}
		@include mobile {
			@include justify-content(center);
			height: $sponsor-banner-height-m;
		}
	}
}
.partner-kb-sponsor-item {
	&:not(:last-child) {
		margin-right: 12px;
		@include pc {
			margin-right: 16px;
		}
	}
}
// 로고 커서 초기화
::v-deep {
	.c-logo {
		a {
			cursor: default;
		}
	}
}
</style>
